import React, { useState } from "react";
import EAButton from "../../shared/Buttons/EAButton";
import { BsCalendarRange } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import EAModal from "../../shared/Modal/EAModal";
import EADayCalendar from "../../shared/EADayCalendar/EADayCalendar";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import { format, isToday, isTomorrow } from "date-fns";
import { ExerciseInt } from "../../../models/ExerciseInt";
import { GDANSK_TICKET } from "../Steps/gdanskSaleStepsConsts";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
}

const GdanskDateInput: React.FC<IProps> = ({ form, setForm }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const getButtonTitle = () => {
    if (form.date) {
      if (isToday(form.date)) {
        return `${t("wybrana_data")}: ${t("dzisiaj")}`;
      } else if (isTomorrow(form.date)) {
        return `${t("wybrana_data")}: ${t("jutro")}`;
      } else {
        return `${t("wybrana_data")}: ${format(form.date, "yyyy-MM-dd")}`;
      }
    } else {
      return t("wybierz_date");
    }
  };

  return (
    <div className="gdansk-input-content">
      <h5 className="no-line-height">
        Wybierz datę, od której chcesz zacząć korzystać z{" "}
        {form.productMainType === GDANSK_TICKET ? "biletu" : "karnetu"}
      </h5>
      <EAButton
        title={getButtonTitle()}
        onClick={() => {
          setOpen(!open);
        }}
        variant="outlined"
        endIcon={<BsCalendarRange />}
      />

      <EAModal isOpen={open} onClose={() => setOpen(false)} title={t("wybierz_date")} hideButtons desktopWidth="420px">
        <div className="eamodal__calendar">
          <EADayCalendar
            selectedDate={form.date}
            fromDate={new Date()}
            onSelect={(date) => {
              setForm({ ...form, date, exercise: {} as ExerciseInt });
              setOpen(false);
            }}
          />
        </div>
      </EAModal>
    </div>
  );
};

export default GdanskDateInput;
